import type {SendFn} from '../../entries/setupMessages';
import type {TwilioConversationsInboundPayload} from '../../shared/TwilioConversationsTypes';
import {AppConfig, initialize} from '../../entries/initialize';
import {RequestHandler} from './RequestHandler';

const handleRequest =
  ({send}: AppConfig<'TwilioConversations'>) =>
  async (
    payload: TwilioConversationsInboundPayload,
    respond: SendFn<'TwilioConversations'>,
  ) => {
    const handler = RequestHandler.getInstance(send);
    await handler.handleMethods(payload, respond).catch((e) => {
      respond({
        method: payload.method,
        error: {code: e.code, message: e.message},
      });
    });
  };

const app = (config: AppConfig<'TwilioConversations'>) => {
  config.subscribe(handleRequest(config));
};

initialize({app, owner: 'merchant_support_experience'});
